// 렌더 격리 — 슬롯 위젯·라우트마다 하나씩 감싼다. 한 플러그인이 던져도 나머지는 그려진다 (ADR-048 D5)
import { Component, type ReactNode } from 'react';

import type { PluginErrorReporter } from './host';

interface Props {
  readonly plugin: string;
  readonly onError: PluginErrorReporter;
  readonly fallback?: ReactNode;
  /** 이 값이 바뀌면 실패 상태를 풀고 다시 그려 본다 (예: 화면 경로) */
  readonly resetKey?: string;
  readonly children: ReactNode;
}

interface State {
  readonly failed: boolean;
  readonly resetKey?: string;
}

export class PluginErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false, resetKey: this.props.resetKey };

  static getDerivedStateFromError(): Partial<State> {
    return { failed: true };
  }

  static getDerivedStateFromProps(props: Props, state: State): Partial<State> | null {
    return props.resetKey !== state.resetKey ? { failed: false, resetKey: props.resetKey } : null;
  }

  override componentDidCatch(error: unknown) {
    this.props.onError(this.props.plugin, 'render', error);
  }

  override render() {
    return this.state.failed ? (this.props.fallback ?? null) : this.props.children;
  }
}
